import nextArrowImg from './next-arrow.svg'
import backArrowImg from './back-arrow.svg'

export const images = { nextArrowImg, backArrowImg }
